<template>
    <btn cssClass="btn btn-secondary" icon="fas fa-cloud-download-alt" :click="downloadCsv"></btn>
</template>

<script>
export default {
    props: [
        'columns', 'sort_by', 'sort_direction', 'filters', 'search_query'
    ],
    data() {
        return {
        };
    },
    methods: {
        downloadCsv() {
            let url = this.url(`admin/list-campaign/csv`);
            url += '?columns=' + encodeURIComponent(JSON.stringify(this.columns));
            if (this.sort_by) url += '&sort_by=' + encodeURIComponent(this.sort_by);
            if (this.sort_direction) url += '&sort_direction=' + encodeURIComponent(this.sort_direction);
            if (this.search_query) url += '&search_query=' + encodeURIComponent(this.search_query);
            url += '&filters=' + encodeURIComponent(JSON.stringify(this.filters));
            window.location.href=url;
        },
    }
}
</script>